import { FC } from 'react';
import { Menu } from 'primereact/menu';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { UserRoles } from 'enums';
import userStore from 'store/UserStore';
import {
  AUTH_ROUTE,
  EXPORT_R00T_ROUTE,
  PUSH_NOTIFICATIONS_ROUTE,
  USERS_ROUTE,
  VERSIONING_ROUTE,
} from 'routes/paths';

type Props = {
  children: React.ReactNode;
};

const DefaultLayout: FC<Props> = ({ children }) => {
  const navigation = useNavigate();
  const location = useLocation();

  const items = [
    {
      label: 'Пользователи',
      command: () => navigation(USERS_ROUTE),
      className: location.pathname === USERS_ROUTE ? 'active' : '',
    },
    {
      label: 'Выгрузка',
      command: () => navigation(EXPORT_R00T_ROUTE),
      className: location.pathname === EXPORT_R00T_ROUTE ? 'active' : '',
    },
    {
      label: 'Версионирование МП',
      command: () => navigation(VERSIONING_ROUTE),
      className: location.pathname === VERSIONING_ROUTE ? 'active' : '',
    },
    {
      label: 'Push-уведомления',
      command: () => navigation(PUSH_NOTIFICATIONS_ROUTE),
      className: location.pathname === PUSH_NOTIFICATIONS_ROUTE ? 'active' : '',
    },
    // todo После готового Апи раскомментить
    // {
    //   label: 'Страницы',
    //   command: () => navigation(STATIC_PAGES_ROUTE),
    //   className: location.pathname === STATIC_PAGES_ROUTE ? 'active' : '',
    // },
    {
      label: 'Выйти',
      command: () => {
        localStorage.clear();
        userStore.setRole(UserRoles.USER);
        navigation(AUTH_ROUTE);
      },
    },
  ];

  return (
    <div className="grid">
      <div className="xl:col-2 lg:col-3 md:col-3 sm:col-3 sticky top-0 h-screen bg-primary shadow-6">
        <LogoContainer className="pt-4 mb-8 -ml-2 flex justify-content-center">
          <LogoWrapper>
            <LogoText>Sugar-Check</LogoText>
          </LogoWrapper>
        </LogoContainer>
        <StyledMenu
          model={items}
          className="w-full bg-primary"
        />
      </div>
      <div className="xl:col-10 lg:col-9 md:col-9 sm:col-3 p-6">{children}</div>
    </div>
  );
};

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 24px;
  border-radius: 12px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.05) 100%
  );
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

const LogoText = styled.h1`
  color: var(--primary-color-text, #ffffff);
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  text-align: center;
  letter-spacing: 1px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  background: linear-gradient(
    135deg,
    #ffffff 0%,
    rgba(255, 255, 255, 0.8) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  position: relative;
`;

const StyledMenu = styled(Menu)`
  border-radius: 0;
  border: none;

  .p-menuitem {
    height: 50px;

    &:last-child {
      position: relative;

      &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 1px;
        background-color: rgba(6, 136, 147, 0.5);
      }
    }

    &-link {
      height: 50px;

      &:hover {
        background-color: var(--primary-600) !important;
        transition: background-color 0.3s ease;
      }
    }

    &.active {
      background-color: var(--primary-600) !important;
      transition: background-color 0.3s ease;
    }
  }

  .p-menuitem-text {
    color: var(--primary-color-text) !important;
    font-size: 18px !important;
  }
`;

const DefaultLayoutObserver = observer(DefaultLayout);

export { DefaultLayoutObserver as DefaultLayout };
